import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { Book, Course } from "../../types/types";
export type CartDTO = {
  cartId: string;
  courses: Course[];
  packages: {
    actualPrice_egp:string;
    discountPrice_egp:string;
    courses:Course[];
    name:string;
    actualPrice_usd:string;
    discountPrice_usd:string;
    id:string;

}[]
  books: Book[];
  total_actualPrice_egp: number;
  total_discountPrice_egp: number;
  total_actualPrice_usd:number;
  total_discountPrice_usd:number;
};

interface CartResponse {
  data?: CartDTO;
  error?: ApiError;
}

export const GetCart = async (): Promise<CartResponse> => {
  try {
    const response = await axios.get("/cart/getCart");
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
